import {formDataRequest, getRequest, postRequest} from '../libs/AxiosService.util';

export async function serviceCreateSalesIncentivePayout(params) {
    return await formDataRequest('cr/create', params);
}
export async function serviceUpdateSalesIncentivePayout(params) {
    return await postRequest('cr/update', params);
}

export async function serviceDeleteSalesIncentivePayout(params) {
    return await postRequest('cr/delete', params);
}
export async function serviceGetSalesIncentivePayoutDetails(params) {
    return await postRequest('sales/incentive/payout/detail', params);
}
export async function serviceGetSalesIncentivePayout(params) {
    return await postRequest('sales/incentive/payout', params);
}
export async function serviceDetailsSalesIncentivePayout(params) {
    return await postRequest('cr/details', params);
}
export async function serviceGetSalesIncentivePayoutDetail(params){
    return await getRequest('employee/claims/type',params)
}
export async function serviceProcessSalesIncentivePayout(params) {
    return await postRequest('sales/incentive/payout/process', params);
}
export async function serviceRejectSalesIncentivePayout(params) {
    return await postRequest('cr/reject', params);
}
export async function serviceExportSalesIncentivePayoutList(params) {
    return await postRequest('sales/incentive/payout/export', params);
}
export async function serviceExportBankSheetList(params) {
    return await postRequest('sales/incentive/payout/export/bank/transfer/details', params);
}

export async function serviceVerifySalesIncentivePayoutImport(params) {
    return await formDataRequest('sales/incentive/payout/import/bank/transfer/details/verify', params);
}

export async function serviceImportSalesIncentivePayout(params) {
    return await formDataRequest('sales/incentive/payout/import/bank/transfer/details', params);
}

export async function serviceDownloadSalesIncentivePayoutSample(params) {
    return await getRequest('sales/incentive/payout/sample/csv', params);
}

export async function servicePayoutOverallDetails(params) {
    return await postRequest('sales/incentive/overall/incentive/detail', params);
}

